import { cn } from '@mc/educator-design-system'

export interface ListCardItem {
  id: string | number
  label: string
}

export interface ListCardProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string
  items: ListCardItem[]
  itemsPerColumn: number
}

export const ListCard = ({
  title,
  items,
  itemsPerColumn,
  className,
  ...rest
}: ListCardProps) => {
  const columns = [
    items.slice(0, itemsPerColumn),
    items.slice(itemsPerColumn, itemsPerColumn * 2),
  ]

  return (
    <div className={cn('p-4', className)} {...rest}>
      <h2 className='text-body-2 font-semibold text-edu-neutral-charcoal mb-[70px]'>
        {title}
      </h2>
      <div className='grid grid-cols-2 gap-4'>
        {columns.map((column, columnIndex) => (
          <ul key={columnIndex} className='list-none p-0 m-0'>
            {column.map((item) => (
              <li
                key={item.id}
                className='py-1.5 border-t border-edu-neutral-charcoal text-body-2 text-edu-neutral-charcoal'
              >
                {item.label}
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  )
}
